import { cn } from "cn"

import type { FlightBadge } from "@/lib/flight-utils"
import IconHeart from "@/components/icons/heart"
import { Badge } from "@/components/ui/badge"

interface FlightOptionBadgesProps {
  badges: FlightBadge[]
  favorite?: boolean
  className?: string
}

export function FlightOptionBadges({
  badges,
  favorite,
  className,
}: FlightOptionBadgesProps) {
  if (badges.length === 0 && !favorite) return null

  return (
    <div className={cn("no-translate flex items-center gap-1.5", className)}>
      {badges.map((b) => (
        <Badge key={b.key} color={b.color ?? "gray"}>
          {b.label}
        </Badge>
      ))}
      {favorite ? (
        <IconHeart
          key="favorite"
          className="fill-saved stroke-saved"
          size={18}
        />
      ) : null}
    </div>
  )
}

export function FlightSourceBadge({
  sourceType,
  className,
}: {
  sourceType?: string
  className?: string
}) {
  if (!sourceType) return null

  return (
    <Badge
      color={sourceType === "NDC" ? "light-yellow" : "gray"}
      className={cn("no-translate", className)}
    >
      {sourceType}
    </Badge>
  )
}
